import styled, { css } from 'styled-components';

export const Badge = styled.span(
  ({ theme }) => css`
    ${theme.typography.button.s};
    background: ${theme.co.success98};
    color: ${theme.co.success20};
    border-radius: ${theme.bo.small};
    padding: ${theme.sz.s1} ${theme.sz.s2};
    display: inline-block;
    white-space: nowrap;
  `,
);
